import React, { useEffect, useState } from "react";
import { loginBack } from "helper/constant";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import AuthActions from "redux/auth/actions";
import enhancer from "./enhancer/LoginFormEnhancer";
import { checkApi, loginApi } from "services/authServices";
import NavigationActions from "redux/navigation/actions";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Loader from "components/Loader";

const { login, setUser } = AuthActions;

const { success, error, fetching } = NavigationActions;

const Login = (props) => {
  const [togglePassword, setTogglePassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    let { values, handleSubmit, isValid } = props;

    if (isValid) {
      fetching();

      setLoading(true);

      try {
        const data = await loginApi(values);
        if (data.success) {
          success(data.message);
          props.login(data.data);
          props.history.push("/events");
          let userData = data.data;
          props.setUser(userData);
        } else {
          error(data.message);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
    handleSubmit();
  };

  const {
    values,
    handleChange,
    handleBlur,
    errors,
    touched,
    submitCount,
    isValid,
    token,
  } = props;

  const loginContainer = {
    backgroundImage: `url(${loginBack})`,
    backgroundPosition: "center center",
    backgroundSize: "cover",
    position: "fixed",
    overflow: "auto",
    top: 0,
    bottom: 0,
  };

  const checkLogin = async () => {
    fetching();
    await checkApi(token).then((data) => {
      if (data.success) {
        success();
        props.history.push("/events");
      } else {
        error();
      }
    });
  };

  useEffect(() => {
    token !== null && checkLogin();
    // eslint-disable-next-line
  }, []);
  const Error = (props) => {
    const field1 = props.field;
    if ((errors[field1] && touched[field1]) || submitCount > 0) {
      return (
        <span className={props.class ? props.class : "error-msg"}>
          {errors[field1]}
        </span>
      );
    } else {
      return <span />;
    }
  };

  return (
    <div className="container-fluid" style={loginContainer}>
      <div className="form-container">
        <div className="login-icon"></div>
        <div className="login-title">Sign in to your account</div>
        <form className="pa-24" onSubmit={handleLogin}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              className="form-control react-form-input"
              id="email"
              onChange={handleChange}
              value={values.email}
              onBlur={handleBlur}
              placeholder="Email"
            />
            <Error field="email" />
          </div>

          <div className="form-group">
            <label>Password</label>

            <div className="input-group mb-3">
              <input
                type={togglePassword ? "text" : "password"}
                className="form-control react-form-input"
                id="password"
                onChange={handleChange}
                value={values.password}
                onBlur={handleBlur}
                placeholder="Enter Password"
              />
              <div className="input-group-append">
                {togglePassword ? (
                  <VisibilityOff onClick={() => setTogglePassword(false)} />
                ) : (
                  <Visibility
                    onClick={() => {
                      setTogglePassword(true);
                    }}
                  />
                )}
              </div>
            </div>
            <Error field="password" />
          </div>

          <div className="form-check text-center mtb-16">
            <input
              type="checkbox"
              className="form-check-input"
              id="exampleCheck1"
            />
            <label className="form-check-label" htmlFor="exampleCheck1">
              Remember me
            </label>
          </div>
          <button
            type="submit"
            className="btn form-button siteenterbutton"
            disabled={isValid ? false : true}
          >
            Login
          </button>
          <div
            className="text-center link-label"
            onClick={() => props.history.push("/forgotPassword")}
          >
            Forgot Password ?
          </div>
        </form>
      </div>
      {loading && <Loader />}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    token: state.auth.accessToken,
  };
};

export default compose(
  withRouter,
  enhancer,
  connect(mapStateToProps, {
    login,
    success,
    error,
    fetching,
    setUser,
  })
)(Login);
